import React from "react"
import styled from "styled-components"
import { useTranslations } from "next-intl"

import constants from "~/style/constants"

const Input = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  padding: 0;
  border: none;
  background: white;
  outline: none;
  height: 35px;
  width: 100%;
  max-width: 121px;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  color: ${(props) => props.theme.colors.text.input};
  &::placeholder {
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
  caret-color: ${(props) => props.theme.colors.primary};
  text-align: center;
  border-right: ${(props) =>
    props.borderRight ? "1px solid #D5D8DB" : "0px solid #D5D8DB"};
  border-radius: 0;

  @media (max-width: 768px) {
    height: 30px;
    font-size: 0.9rem;
    max-width: none;
    flex: 1;
  }

  @media (max-width: 480px) {
    height: 28px;
    font-size: 0.85rem;
  }
`

const OuterWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  max-width: 364px;
  width: 100%;
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  background: white;
  border-radius: 4px;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};

  @media (max-width: 768px) {
    height: 56px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    height: 48px;
  }
`
const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1px 1px 1px 1px;
`

const NameInput = ({
  firstName,
  middleName,
  lastName,
  handleChange,
  error,
}) => {
  const translate = useTranslations("form.general.name.label")

  return (
    <OuterWrapper error={error}>
      <InnerWrapper>
        <Input
          placeholder={translate("first")}
          borderRight
          value={firstName}
          name="firstName"
          onChange={handleChange}
        />
        <Input
          placeholder={translate("middle")}
          borderRight
          value={middleName}
          name="middleName"
          onChange={handleChange}
        />
        <Input
          placeholder={translate("last")}
          borderRight={false}
          value={lastName}
          name="lastName"
          onChange={handleChange}
        />
      </InnerWrapper>
    </OuterWrapper>
  )
}

export default NameInput
